import React, { useState } from "react";
import { Box, Typography, IconButton, useTheme, useMediaQuery } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import TextInput from "src/components/input/TextInput"; // Ajusta la ruta según sea necesario
import FileInput from "src/components/input/FileInput";
import { opcionesTipoExperiencia } from "src/utils/constantes";

interface ExperienciaItemProps {
  index: number;
  remove: (index: number) => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
  values: any;
  aspiranteId: string;
}

const ExperienciaItem: React.FC<ExperienciaItemProps> = ({
  index,
  remove,
  setFieldValue,
  values, 
  aspiranteId
}) => {
  const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
    return (
  <Box
    mx={isMobile ? 0 : 10}
    sx={{
      border: "1px solid #ddd",
      borderRadius: "8px",
      padding: 2,
      marginBottom: 2,
      position: "relative",
    }}
  >
    <Typography
      variant="subtitle1"
      textAlign="left"
      fontWeight="bold"
      gutterBottom
    >
      Experiencia {index + 1}
    </Typography>
    <Box
      display="flex"
      sx={{
        flexDirection: { xs: "column", md: "row" },
        gap: { xs: 0, md: 2 },
      }}
    >
      <TextInput
        label="Tipo"
        name={`experienciasLaborales[${index}].tipo`}
        type="select"
        opciones={opcionesTipoExperiencia}
      />
      <TextInput
        label="Nombre del cargo desempeñado"
        name={`experienciasLaborales[${index}].cargo`}
        type="text"
      />
      <TextInput
        label="Empresa o institución"
        name={`experienciasLaborales[${index}].nombreEmpresaInstitucion`}
        type="text"
      />
    </Box>
    <Box
      display="flex"
      sx={{
        flexDirection: { xs: "column", md: "row" },
        gap: { xs: 0, md: 2 },
      }}
    >
      <TextInput
        label="Fecha de inicio"
        name={`experienciasLaborales[${index}].fechaInicio`}
        InputLabelProps={{ shrink: true }}
        type="date"
      />
      <TextInput
        label="Fecha de finalización o actual"
        name={`experienciasLaborales[${index}].fechaFin`}
        InputLabelProps={{ shrink: true }}
        type="date"
      />
      <TextInput
        label="Nombre de quien acredita la experiencia en el certificado"
        name={`experienciasLaborales[${index}].nombreJefeInmediato`}
        type="text"
      />
    </Box>
    <TextInput
        label="Objeto del contrato o actividades"
        name={`experienciasLaborales[${index}].resumenFunciones`}
        type="textarea"
      />
    <FileInput
    id={`experienciasLaborales[${index}].fechaExpedicionCertificado`}
      setValue={(value: any) => {
        setFieldValue(`experienciasLaborales[${index}].soporteId`, value);
      }}
      value={values.experienciasLaborales[index].soporteId}
      selectedFile={selectedFile}
      setSelectedFile={setSelectedFile}
      label="Certificado de experiencia"
      proyectoId=""
      aspiranteId={aspiranteId}
    />
    <IconButton
      onClick={() => remove(index)}
      sx={{ position: "absolute", top: 8, right: 8 }}
    >
      <DeleteIcon color="error" />
    </IconButton>
  </Box>
)};

export default ExperienciaItem;
